(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    /* ── Intercept header menu to open filter modal on catalog page ── */
    var headerMenuSummary = document.querySelector('.header__icon--menu');
    if (headerMenuSummary) {
      headerMenuSummary.addEventListener('click', function(e) {
        /* Only intercept below the desktop breakpoint (<= 1200px), matching the catalog grid */
        if (window.innerWidth > 1200) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        /* Prevent native menu drawer from opening */
        var details = document.getElementById('Details-menu-drawer-container');
        if (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-open');
        }

        /* Open the filter modal instead */
        var filterModal = document.querySelector('[data-filter-modal]');
        if (filterModal) {
          filterModal.classList.add('catalog-filter-modal--entering');
          filterModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          document.body.style.touchAction = 'none';
          filterModal.offsetHeight;
          filterModal.classList.remove('catalog-filter-modal--entering');
        }
      }, true);
    }

    /* ── Helpers ── */
    function lockScroll() {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    }
    function unlockScroll() {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }

    /* ──────────────────────────────────────
       SORT MODAL
       ────────────────────────────────────── */
    var sortModal = document.querySelector('[data-sort-modal]');
    var openSortBtn = document.querySelector('[data-open-sort-modal]');
    var closeSortBtn = document.querySelector('[data-close-sort-modal]');

    function openSortModal() {
      if (!sortModal) return;
      sortModal.classList.add('catalog-sort-modal--entering');
      sortModal.setAttribute('aria-hidden', 'false');
      lockScroll();
      /* Trigger reflow for animation */
      sortModal.offsetHeight;
      sortModal.classList.remove('catalog-sort-modal--entering');
    }

    function closeSortModal() {
      if (!sortModal) return;
      sortModal.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    if (openSortBtn) openSortBtn.addEventListener('click', openSortModal);
    if (closeSortBtn) closeSortBtn.addEventListener('click', closeSortModal);

    /* Sort options (mobile modal) */
    if (sortModal) {
      sortModal.addEventListener('click', function(e) {
        var option = e.target.closest('[data-mobile-sort]');
        if (!option) return;

        /* Update active state */
        sortModal.querySelectorAll('.catalog-sort-modal__option').forEach(function(el) {
          el.classList.remove('catalog-sort-modal__option--active');
          el.querySelector('.catalog-sort-modal__dash').textContent = '';
        });
        option.classList.add('catalog-sort-modal__option--active');
        option.querySelector('.catalog-sort-modal__dash').textContent = '-';

        /* Sort the grid */
        var sortType = option.getAttribute('data-mobile-sort');
        sortGrid(sortType);

        /* Close modal and scroll to top */
        setTimeout(function() {
          closeSortModal();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 150);
      });
    }

    /* ──────────────────────────────────────
       FILTER MODAL
       ────────────────────────────────────── */
    var filterModal = document.querySelector('[data-filter-modal]');
    var closeFilterBtn = document.querySelector('[data-close-filter-modal]');

    function openFilterModal() {
      if (!filterModal) return;
      filterModal.classList.add('catalog-filter-modal--entering');
      filterModal.setAttribute('aria-hidden', 'false');
      lockScroll();
      filterModal.offsetHeight;
      filterModal.classList.remove('catalog-filter-modal--entering');
    }

    function closeFilterModal() {
      if (!filterModal) return;
      filterModal.setAttribute('aria-hidden', 'true');
      unlockScroll();

      /* Reset header menu details state so "Close" reverts to "Menu" */
      var details = document.getElementById('Details-menu-drawer-container');
      if (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-open');
      }
    }

    if (closeFilterBtn) closeFilterBtn.addEventListener('click', closeFilterModal);

    /* Tab switching */
    var tabs = document.querySelectorAll('[data-filter-tab]');
    var panels = document.querySelectorAll('[data-filter-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-filter-tab');

        tabs.forEach(function(t) { t.classList.remove('catalog-filter-modal__tab--active'); });
        panels.forEach(function(p) { p.classList.remove('catalog-filter-modal__panel--active'); });

        tab.classList.add('catalog-filter-modal__tab--active');
        var panel = document.querySelector('[data-filter-panel="' + target + '"]');
        if (panel) panel.classList.add('catalog-filter-modal__panel--active');

        /* Hide empty categories in mobile sale panel */
        if (target === 'sale') {
          hideEmptySaleCategories();
        }
      });
    });

    /* Hide categories with no sale products in mobile sale panel */
    function hideEmptySaleCategories() {
      var cards = document.querySelectorAll('.catalog-card');
      var counts = {};
      cards.forEach(function(card) {
        if (card.hasAttribute('data-sold-out')) return;
        if (!card.hasAttribute('data-in-sale')) return;
        var cats = (card.getAttribute('data-categories') || '').split(',');
        cats.forEach(function(c) { if (c) counts[c] = (counts[c] || 0) + 1; });
      });

      var saleItems = document.querySelectorAll('[data-modal-sale]');
      saleItems.forEach(function(item) {
        var slug = item.getAttribute('data-modal-sale');
        if (slug === 'all-sale') return;
        item.style.display = counts[slug] ? '' : 'none';
      });

      /* Hide entire sections if all items are hidden */
      var sections = document.querySelectorAll('[data-filter-panel="sale"] .catalog-categories-detail__section');
      sections.forEach(function(sec) {
        var visibleItems = sec.querySelectorAll('[data-modal-sale]');
        var hasVisible = false;
        visibleItems.forEach(function(item) {
          if (item.style.display !== 'none') hasVisible = true;
        });
        sec.style.display = hasVisible ? '' : 'none';
      });
    }

    /* Brand filter (mobile modal) */
    var brandItems = document.querySelectorAll('[data-brand-filter]');
    brandItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var brand = item.getAttribute('data-brand-filter');
        filterByBrand(brand);
        closeFilterModal();
      });
    });

    /* Category items (mobile modal) — filter by category and close */
    var modalCategoryItems = document.querySelectorAll('[data-modal-category]');
    modalCategoryItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var slug = item.getAttribute('data-modal-category');
        filterByCategory(slug);
        closeFilterModal();
      });
    });

    /* Sale items (mobile modal) — filter by category in sale mode and close */
    var modalSaleItems = document.querySelectorAll('[data-modal-sale]');
    modalSaleItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var slug = item.getAttribute('data-modal-sale');
        if (slug === 'all-sale') {
          showAllSale();
        } else {
          /* Activate sale mode on desktop sidebar tab */
          var saleTab = document.querySelector('[data-sidebar-tab="sale"]');
          if (saleTab) {
            var allTabs = document.querySelectorAll('[data-sidebar-tab]');
            allTabs.forEach(function(t) { t.classList.remove('menu-list__link--tab-active'); });
            saleTab.classList.add('menu-list__link--tab-active');
          }
          filterByCategory(slug);
        }
        closeFilterModal();
      });
    });

    /* Promo brand filter (mobile modal) */
    var modalPromoItems = document.querySelectorAll('[data-modal-promo]');
    modalPromoItems.forEach(function(item) {
      item.addEventListener('click', function() {
        /* Activate promo mode on desktop sidebar tab so filterByBrand scopes to promo */
        var promoTab = document.querySelector('[data-sidebar-tab="promo"]');
        if (promoTab) {
          var allTabs = document.querySelectorAll('[data-sidebar-tab]');
          allTabs.forEach(function(t) { t.classList.remove('menu-list__link--tab-active'); });
          promoTab.classList.add('menu-list__link--tab-active');
        }
        var brand = item.getAttribute('data-modal-promo');
        if (brand === 'all-promo') {
          showAllPromo();
        } else {
          filterByBrand(brand);
        }
        closeFilterModal();
      });
    });

    /* View All button */
    var viewAllBtn = document.querySelector('[data-view-all-brands]');
    if (viewAllBtn) {
      viewAllBtn.addEventListener('click', function() {
        filterByBrand('all');
        closeFilterModal();
      });
    }

    /* Keyword filter (mobile modal) */
    var keywordItems = document.querySelectorAll('[data-keyword-filter]');
    keywordItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var slug = item.getAttribute('data-keyword-filter');
        filterByKeyword(slug);
        closeFilterModal();
      });
    });

    /* View All Keywords button */
    var viewAllKeywordsBtn = document.querySelector('[data-view-all-keywords]');
    if (viewAllKeywordsBtn) {
      viewAllKeywordsBtn.addEventListener('click', function() {
        filterByKeyword('all');
        closeFilterModal();
      });
    }

    /* View All Categories button */
    var viewAllCategoriesBtn = document.querySelector('[data-view-all-categories]');
    if (viewAllCategoriesBtn) {
      viewAllCategoriesBtn.addEventListener('click', function() {
        filterByBrand('all');
        closeFilterModal();
      });
    }

    /* ──────────────────────────────────────
       SHARED: Sort grid function
       ────────────────────────────────────── */
    function sortGrid(sortType) {
      var grid = document.getElementById('catalog-grid');
      if (!grid) return;
      var cards = Array.from(grid.querySelectorAll('.catalog-card'));

      cards.sort(function(a, b) {
        switch (sortType) {
          case 'price-ascending':
            return Number(a.dataset.price) - Number(b.dataset.price);
          case 'price-descending':
            return Number(b.dataset.price) - Number(a.dataset.price);
          case 'created-descending':
          case 'trending':
            return Number(b.dataset.created) - Number(a.dataset.created);
          default:
            return Number(b.dataset.popularity || 50) - Number(a.dataset.popularity || 50);
        }
      });

      cards.forEach(function(card) { grid.appendChild(card); });
      updateCatalogBanners();
    }

    /* ──────────────────────────────────────
       SHARED: Brand filter function
       ────────────────────────────────────── */
    function filterByBrand(brand, updateHash) {
      var cards = document.querySelectorAll('.catalog-card[data-vendor]');
      var promoMode = document.querySelector('[data-sidebar-tab="promo"].menu-list__link--tab-active') !== null;
      cards.forEach(function(card) {
        if (promoMode && !card.hasAttribute('data-in-promo')) { card.style.display = 'none'; return; }
        if (brand === 'all') {
          /* In promo mode, keep sold-out promo products visible (they show a SOLD OUT label) */
          if (!promoMode && card.hasAttribute('data-sold-out')) { card.style.display = 'none'; return; }
          card.style.display = '';
        } else if (card.getAttribute('data-vendor') === brand) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });

      /* Also update desktop sidebar active state */
      var sidebar = document.getElementById('catalog-sidebar');
      if (sidebar) {
        sidebar.querySelectorAll('.catalog-sidebar__link').forEach(function(el) {
          el.classList.remove('catalog-sidebar__link--active');
        });
        var activeLink = sidebar.querySelector('[data-brand="' + (brand === 'all' ? 'all' : brand) + '"]');
        if (activeLink) activeLink.classList.add('catalog-sidebar__link--active');
      }

      /* Update URL hash so back button restores filter */
      if (updateHash !== false) {
        if (brand === 'all') {
          history.pushState({ brand: 'all' }, '', window.location.pathname);
        } else {
          history.pushState({ brand: brand }, '', window.location.pathname + '#brand=' + encodeURIComponent(brand));
        }
      }
      updateCatalogBanners(brand === 'all');
    }

    /* ──────────────────────────────────────
       SHARED: Keyword filter function
       ────────────────────────────────────── */
    var bestKeywords = ['pdrn','niacinamide','centella','vitamin-c','retinol','collagen','hyaluronic-acid','peptide','glutathione','exosome','retinal','ceramide','heartleaf','tea-tree','bakuchiol'];

    function filterByKeyword(slug, updateHash) {
      var cards = document.querySelectorAll('.catalog-card');
      cards.forEach(function(card) {
        var keywords = card.getAttribute('data-keywords') || '';
        if (slug === 'all') {
          if (card.hasAttribute('data-sold-out')) { card.style.display = 'none'; return; }
          var kwArr = keywords ? keywords.split(',') : [];
          var hasBest = kwArr.some(function(k) { return bestKeywords.indexOf(k) !== -1; });
          card.style.display = hasBest ? '' : 'none';
        } else if (keywords.split(',').indexOf(slug) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });

      /* Update desktop sidebar active state */
      var sidebar = document.getElementById('catalog-sidebar');
      if (sidebar) {
        sidebar.querySelectorAll('[data-keyword]').forEach(function(el) {
          el.classList.remove('catalog-sidebar__link--active');
        });
        var activeLink = sidebar.querySelector('[data-keyword="' + slug + '"]');
        if (activeLink) activeLink.classList.add('catalog-sidebar__link--active');
      }

      /* Update URL hash */
      if (updateHash !== false) {
        if (slug === 'all') {
          history.pushState({ keyword: 'all' }, '', window.location.pathname);
        } else {
          history.pushState({ keyword: slug }, '', '#keyword=' + encodeURIComponent(slug));
        }
      }
      updateCatalogBanners(false);
    }

    /* ──────────────────────────────────────
       SHARED: Show all sale products
       ────────────────────────────────────── */
    function showAllSale() {
      var cards = document.querySelectorAll('.catalog-card');
      cards.forEach(function(card) {
        if (card.hasAttribute('data-sold-out')) { card.style.display = 'none'; return; }
        var isOnSale = card.hasAttribute('data-in-sale');
        card.style.display = isOnSale ? '' : 'none';
      });

      /* Clear any active category/keyword highlights in sidebar */
      var activeLinks = document.querySelectorAll('.catalog-sidebar__link--active');
      activeLinks.forEach(function(link) { link.classList.remove('catalog-sidebar__link--active'); });
      updateCatalogBanners(false);
    }

    /* ──────────────────────────────────────
       SHARED: Show all promo products
       ────────────────────────────────────── */
    function showAllPromo() {
      var cards = document.querySelectorAll('.catalog-card');
      cards.forEach(function(card) {
        /* Promo is a curated feature: show promo products even when sold out.
           The card renders a "SOLD OUT" label in place of the price. */
        card.style.display = card.hasAttribute('data-in-promo') ? '' : 'none';
      });

      /* Clear active highlights, then mark the promo "All" link as the default selection */
      var activeLinks = document.querySelectorAll('.catalog-sidebar__link--active');
      activeLinks.forEach(function(link) { link.classList.remove('catalog-sidebar__link--active'); });
      var promoAll = document.querySelector('[data-sidebar-panel="promo"] [data-promo-brand="all"]');
      if (promoAll) promoAll.classList.add('catalog-sidebar__link--active');
      updateCatalogBanners(false);
    }

    /* ──────────────────────────────────────
       SHARED: Category filter function
       ────────────────────────────────────── */
    var ALL_CATEGORY_SLUGS = ['skincare', 'makeup', 'cleansing', 'hair-care', 'body-care', 'others'];

    function filterByCategory(slug, updateHash) {
      var cards = document.querySelectorAll('.catalog-card');
      /* Check if sale tab is active in the header */
      var saleTab = document.querySelector('[data-sidebar-tab="sale"].menu-list__link--tab-active');
      var isSaleMode = saleTab !== null;
      var isAllCategory = ALL_CATEGORY_SLUGS.indexOf(slug) !== -1;

      cards.forEach(function(card) {
        if ((isSaleMode || isAllCategory) && card.hasAttribute('data-sold-out')) { card.style.display = 'none'; return; }
        var categories = card.getAttribute('data-categories') || '';
        var catArr = categories ? categories.split(',') : [];
        var matchesCategory = catArr.indexOf(slug) !== -1;

        if (isSaleMode) {
          var isOnSale = card.hasAttribute('data-in-sale');
          card.style.display = (matchesCategory && isOnSale) ? '' : 'none';
        } else {
          card.style.display = matchesCategory ? '' : 'none';
        }
      });

      /* Update desktop sidebar active state */
      var sidebar = document.getElementById('catalog-sidebar');
      if (sidebar) {
        sidebar.querySelectorAll('[data-category]').forEach(function(el) {
          el.classList.remove('catalog-sidebar__link--active');
        });
        var activeLink = sidebar.querySelector('[data-category="' + slug + '"]');
        if (activeLink) activeLink.classList.add('catalog-sidebar__link--active');
      }

      /* Update URL hash */
      if (updateHash !== false) {
        history.pushState({ category: slug }, '', '#category=' + encodeURIComponent(slug));
      }
      updateCatalogBanners(false);
    }

    /* Restore brand, keyword, or category filter from URL hash on page load */
    function restoreFromHash() {
      var hash = window.location.hash;
      if (hash && hash.indexOf('#brand=') === 0) {
        var brand = decodeURIComponent(hash.substring(7));
        filterByBrand(brand, false);
      } else if (hash && hash.indexOf('#keyword=') === 0) {
        var slug = decodeURIComponent(hash.substring(9));
        filterByKeyword(slug, false);
      } else if (hash && hash.indexOf('#category=') === 0) {
        var cat = decodeURIComponent(hash.substring(10));
        filterByCategory(cat, false);
      }
    }

    /* Handle back/forward navigation */
    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.brand) {
        filterByBrand(e.state.brand, false);
      } else if (e.state && e.state.keyword) {
        filterByKeyword(e.state.keyword, false);
      } else if (e.state && e.state.category) {
        filterByCategory(e.state.category, false);
      } else {
        restoreFromHash();
        if (!window.location.hash) {
          filterByBrand('all', false);
        }
      }
    });

    /* Show product count per keyword in sidebar and mobile filter */
    (function() {
      var cards = document.querySelectorAll('.catalog-card');
      var counts = {};
      cards.forEach(function(card) {
        if (card.hasAttribute('data-sold-out')) return;
        var kws = (card.getAttribute('data-keywords') || '').split(',');
        kws.forEach(function(k) { if (k) counts[k] = (counts[k] || 0) + 1; });
      });
      document.querySelectorAll('[data-keyword]').forEach(function(el) {
        var slug = el.getAttribute('data-keyword');
        var count = counts[slug] || 0;
        var textEl = el.querySelector('.catalog-sidebar__link-text');
        if (textEl) textEl.textContent = textEl.textContent + ' (' + count + ')';
      });
      document.querySelectorAll('[data-keyword-filter]').forEach(function(el) {
        var slug = el.getAttribute('data-keyword-filter');
        var count = counts[slug] || 0;
        el.textContent = el.textContent + ' (' + count + ')';
      });
    })();

    /* ──────────────────────────────────────
       BANNER placement + visibility
       ────────────────────────────────────── */
    var bannerDefaultView = true;
    function updateCatalogBanners(isDefault) {
      if (typeof isDefault === 'boolean') bannerDefaultView = isDefault;
      var grid = document.getElementById('catalog-grid');
      if (!grid) return;
      var banners = grid.querySelectorAll('[data-banner]');
      if (!banners.length) return;
      banners.forEach(function(banner) {
        if (!bannerDefaultView) { banner.hidden = true; return; }
        var pos = parseInt(banner.dataset.position, 10) || 2;
        var visibleCards = Array.prototype.filter.call(
          grid.querySelectorAll('.catalog-card'),
          function(c) { return c.style.display !== 'none'; }
        );
        if (visibleCards.length < pos) { banner.hidden = true; return; }
        var anchor = visibleCards[pos - 1];
        if (anchor && anchor.nextSibling !== banner) {
          grid.insertBefore(banner, anchor.nextSibling);
        }
        banner.hidden = false;
      });
    }
    updateCatalogBanners(true);

    restoreFromHash();

    /* ──────────────────────────────────────
       BANNER CAROUSEL (manual only)
       ────────────────────────────────────── */
    function initBannerCarousels() {
      var banners = document.querySelectorAll('[data-banner]');
      banners.forEach(function(banner) {
        if (banner.dataset.carouselInit) return;
        banner.dataset.carouselInit = '1';
        var track = banner.querySelector('[data-banner-track]');
        var slides = banner.querySelectorAll('[data-banner-slide]');
        var prev = banner.querySelector('[data-banner-prev]');
        var next = banner.querySelector('[data-banner-next]');
        if (!track || slides.length === 0) return;
        var index = 0;
        function go(i) {
          index = Math.max(0, Math.min(slides.length - 1, i));
          track.style.transform = 'translateX(' + (-index * 100) + '%)';
        }
        if (slides.length > 1) {
          if (prev) prev.hidden = false;
          if (next) next.hidden = false;
          if (prev) prev.addEventListener('click', function() { go(index - 1); });
          if (next) next.addEventListener('click', function() { go(index + 1); });
          var startX = null;
          track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
          track.addEventListener('touchend', function(e) {
            if (startX === null) return;
            var dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
            startX = null;
          }, { passive: true });
        }
        go(0);
      });
    }
    initBannerCarousels();

    /* ──────────────────────────────────────
       DESKTOP: Sidebar brand filter
       ────────────────────────────────────── */
    var sidebar = document.getElementById('catalog-sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', function(e) {
        var link = e.target.closest('[data-brand]');
        if (!link) return;
        e.preventDefault();
        filterByBrand(link.getAttribute('data-brand'));
      });
    }

    /* ──────────────────────────────────────
       DESKTOP: Sidebar promo brand filter
       ────────────────────────────────────── */
    if (sidebar) {
      sidebar.addEventListener('click', function(e) {
        var link = e.target.closest('[data-promo-brand]');
        if (!link) return;
        e.preventDefault();
        filterByBrand(link.getAttribute('data-promo-brand'));
        /* Highlight the active link within the promo panel */
        sidebar.querySelectorAll('.catalog-sidebar__link--active').forEach(function(el) {
          el.classList.remove('catalog-sidebar__link--active');
        });
        link.classList.add('catalog-sidebar__link--active');
      });
    }

    /* ──────────────────────────────────────
       DESKTOP: Sidebar keyword filter
       ────────────────────────────────────── */
    if (sidebar) {
      sidebar.addEventListener('click', function(e) {
        var link = e.target.closest('[data-keyword]');
        if (!link) return;
        e.preventDefault();
        filterByKeyword(link.getAttribute('data-keyword'));
      });
    }

    /* ──────────────────────────────────────
       DESKTOP: Sidebar category filter
       ────────────────────────────────────── */
    if (sidebar) {
      sidebar.addEventListener('click', function(e) {
        var link = e.target.closest('[data-category]');
        if (!link) return;
        e.preventDefault();
        filterByCategory(link.getAttribute('data-category'));
      });
    }

    /* ──────────────────────────────────────
       DESKTOP: Sort sidebar
       ────────────────────────────────────── */
    var sortSidebar = document.querySelector('.catalog-sort-sidebar');
    if (sortSidebar) {
      sortSidebar.addEventListener('click', function(e) {
        var link = e.target.closest('[data-sort]');
        if (!link) return;
        e.preventDefault();

        sortSidebar.querySelectorAll('.catalog-sort-sidebar__link').forEach(function(el) {
          el.classList.remove('catalog-sort-sidebar__link--active');
        });
        link.classList.add('catalog-sort-sidebar__link--active');

        sortGrid(link.getAttribute('data-sort'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* ──────────────────────────────────────
       SHARED: Hide empty category links
       ────────────────────────────────────── */
    function hideEmptyCategories(saleOnly) {
      /* Count products per category slug */
      var cards = document.querySelectorAll('.catalog-card');
      var counts = {};
      cards.forEach(function(card) {
        if (card.hasAttribute('data-sold-out')) return;
        if (saleOnly && !card.hasAttribute('data-in-sale')) return;
        var cats = (card.getAttribute('data-categories') || '').split(',');
        cats.forEach(function(c) { if (c) counts[c] = (counts[c] || 0) + 1; });
      });

      /* Show/hide category links based on count */
      var catLinks = document.querySelectorAll('[data-sidebar-panel="category"] [data-category]');
      catLinks.forEach(function(link) {
        var slug = link.getAttribute('data-category');
        var li = link.closest('li');
        if (li) li.style.display = counts[slug] ? '' : 'none';
      });

      /* Hide entire section headings if all children are hidden */
      var sections = document.querySelectorAll('[data-sidebar-panel="category"] .catalog-sidebar__section');
      sections.forEach(function(sec) {
        var visibleItems = sec.querySelectorAll('li[style=""], li:not([style])');
        var hasVisible = false;
        visibleItems.forEach(function(li) {
          if (li.style.display !== 'none') hasVisible = true;
        });
        sec.style.display = hasVisible ? '' : 'none';
      });
    }

    /* ── Sidebar panel toggle (Brands / Category / Sale) ──*/
    (function() {
      var currentView = 'brands';

      function switchSidebarPanel(view) {
        currentView = view;
        var panels = document.querySelectorAll('[data-sidebar-panel]');
        panels.forEach(function(panel) {
          if (panel.dataset.sidebarPanel === view) {
            panel.classList.add('catalog-sidebar__panel--active');
          } else {
            panel.classList.remove('catalog-sidebar__panel--active');
          }
        });

        /* Sync header tab active state */
        var tabs = document.querySelectorAll('[data-sidebar-tab]');
        tabs.forEach(function(tab) {
          if (tab.getAttribute('data-sidebar-tab') === view) {
            tab.classList.add('menu-list__link--tab-active');
          } else {
            tab.classList.remove('menu-list__link--tab-active');
          }
        });

        /* Sale mode: show category panel but filter to sale items only */
        var saleMode = (view === 'sale');
        if (saleMode) {
          /* Show the category panel for sale view */
          panels.forEach(function(panel) {
            if (panel.dataset.sidebarPanel === 'category') {
              panel.classList.add('catalog-sidebar__panel--active');
            } else {
              panel.classList.remove('catalog-sidebar__panel--active');
            }
          });
        }

        /* Filter products based on active tab */
        var cards = document.querySelectorAll('.catalog-card');
        if (saleMode) {
          /* Show all sale products by default, hide empty categories */
          hideEmptyCategories(true);
          showAllSale();
        } else if (view === 'category') {
          /* Default to All Skin Care */
          hideEmptyCategories(false);
          filterByCategory('skincare', false);
        } else if (view === 'keyword') {
          /* Use keyword from URL hash if present, otherwise default to PDRN */
          var kwHash = window.location.hash;
          if (kwHash && kwHash.indexOf('#keyword=') === 0) {
            filterByKeyword(decodeURIComponent(kwHash.substring(9)), false);
          } else {
            filterByKeyword('pdrn', false);
          }
        } else if (view === 'promo') {
          showAllPromo();
        } else {
          /* Reset: restore brand filter if on brands tab (filterByBrand handles sold-out for 'all') */
          if (view === 'brands') {
            var activeLink = document.querySelector('.catalog-sidebar__link--active[data-brand]');
            var brand = activeLink ? activeLink.getAttribute('data-brand') : 'all';
            filterByBrand(brand, false);
          } else {
            cards.forEach(function(card) { card.style.display = ''; });
          }
        }
      }

      // Listen for toggle events from header button
      window.addEventListener('sidebar-view-change', function(e) {
        switchSidebarPanel(e.detail.view);
      });

      // Also directly listen to header tab clicks (backup for timing issues)
      document.addEventListener('click', function(e) {
        var tab = e.target.closest('[data-sidebar-tab]');
        if (!tab) return;
        if (window.location.pathname !== '/') return; // header handles navigation
        var view = tab.getAttribute('data-sidebar-tab');
        // Small delay to let header update tab styling first
        setTimeout(function() { switchSidebarPanel(view); }, 0);
      });

      // Start with view from URL param, or default to Brands
      var initParams = new URLSearchParams(window.location.search);
      var initView = initParams.get('view');
      if (initView && ['category', 'brands', 'keyword', 'sale', 'promo'].indexOf(initView) !== -1) {
        switchSidebarPanel(initView);
      } else {
        switchSidebarPanel('brands');
      }

      // Also reset on bfcache restore
      window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
          switchSidebarPanel('brands');
        }
      });

    })();

    /* Sort by popularity on initial page load */
    sortGrid('popular');

    /* ──────────────────────────────────────
       Load products beyond Shopify's 250-per-paginate cap
       Server renders only 250 cards at a time, so we fetch
       /?sections=catalog&page=N for any remaining pages and
       append the catalog-cards into the grid.
       ────────────────────────────────────── */
    async function loadAdditionalCatalogPages() {
      var grid = document.getElementById('catalog-grid');
      if (!grid) return;

      var pageNum = 2;
      var maxPages = 20;

      while (pageNum <= maxPages) {
        try {
          var res = await fetch('/?sections=catalog&page=' + pageNum, { credentials: 'same-origin' });
          if (!res.ok) break;
          var json = await res.json();
          var html = json.catalog || '';
          if (!html) break;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.catalog-card');
          if (newCards.length === 0) break;

          var basePosition = (pageNum - 1) * 250;
          newCards.forEach(function(card, idx) {
            card.setAttribute('data-default-position', basePosition + idx + 1);
            grid.appendChild(card);
          });

          if (newCards.length < 250) break;
          pageNum++;
        } catch (e) {
          break;
        }
      }

      /* Re-apply current filter so newly appended cards respect it */
      var activeTab = document.querySelector('[data-sidebar-tab].menu-list__link--tab-active');
      var view = activeTab ? activeTab.getAttribute('data-sidebar-tab') : 'brands';
      if (view === 'brands') {
        var activeBrand = document.querySelector('.catalog-sidebar__link--active[data-brand]');
        filterByBrand(activeBrand ? activeBrand.getAttribute('data-brand') : 'all', false);
      } else if (view === 'category') {
        var activeCat = document.querySelector('.catalog-sidebar__link--active[data-category]');
        filterByCategory(activeCat ? activeCat.getAttribute('data-category') : 'skincare', false);
      } else if (view === 'keyword') {
        var activeKw = document.querySelector('.catalog-sidebar__link--active[data-keyword]');
        filterByKeyword(activeKw ? activeKw.getAttribute('data-keyword') : 'all', false);
      } else if (view === 'sale') {
        showAllSale();
      } else if (view === 'promo') {
        var activePromoBrand = document.querySelector('[data-sidebar-panel="promo"] .catalog-sidebar__link--active[data-promo-brand]');
        if (activePromoBrand && activePromoBrand.getAttribute('data-promo-brand') !== 'all') {
          filterByBrand(activePromoBrand.getAttribute('data-promo-brand'), false);
        } else {
          showAllPromo();
        }
      }

      /* Re-apply current sort */
      var activeSort = document.querySelector('.catalog-sort-sidebar__link--active');
      var sortType = activeSort ? activeSort.getAttribute('data-sort') : 'popular';
      sortGrid(sortType);
    }

    loadAdditionalCatalogPages();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
